export const availableBooks = [
  'btc_mxn',
  'eth_btc',
  'eth_mxn',
  'xrp_btc',
  'xrp_mxn',
  'ltc_btc',
  'ltc_mxn',
  'bch_btc',
  'bch_mxn',
  'tusd_btc',
  'tusd_mxn',
  'mana_btc',
  'mana_mxn',
  'bat_btc',
  'bat_mxn',
  'btc_ars',
  'btc_dai',
  'dai_mxn',
  'btc_usd',
  'xrp_usd',
  'eth_usd',
  'dai_ars',
  'btc_brl',
  'eth_ars',
]

export const availableConversions = [
  {
    currency: 'btc',
    allowedConversions: ['mxn', 'eth', 'xrp', 'ltc', 'bch', 'tusd', 'mana', 'bat', 'ars', 'dai', 'usd', 'brl'],
  },
  { currency: 'mxn', allowedConversions: ['btc', 'eth', 'xrp', 'ltc', 'bch', 'tusd', 'mana', 'bat', 'dai'] },
  { currency: 'eth', allowedConversions: ['btc', 'mxn', 'usd', 'ars'] },
  { currency: 'xrp', allowedConversions: ['btc', 'mxn', 'usd'] },
  { currency: 'ltc', allowedConversions: ['btc', 'mxn'] },
  { currency: 'bch', allowedConversions: ['btc', 'mxn'] },
  { currency: 'tusd', allowedConversions: ['btc', 'mxn'] },
  { currency: 'mana', allowedConversions: ['btc', 'mxn'] },
  { currency: 'bat', allowedConversions: ['btc', 'mxn'] },
  { currency: 'ars', allowedConversions: ['btc', 'dai', 'eth'] },
  { currency: 'dai', allowedConversions: ['btc', 'mxn', 'ars'] },
  { currency: 'usd', allowedConversions: ['btc', 'xrp', 'eth'] },
  { currency: 'brl', allowedConversions: ['btc'] },
]
